// Single source of truth for turning a page/org name into a URL slug.
// Used both at publish time (MainNav's handlePublish, which derives each
// page's real published URL from this) and when building default nav links
// from the real page list (globalNavbar.ts) -- those two must never diverge,
// or a nav link and the page it's supposed to point to drift apart again.
// See issue #36.
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
